import React, { createContext, useState } from "react";
import {
  isAuthenticated,
  selectDiscoveryId,
  selectDiscoverySetting
} from "../../../store/reducers";
import DiscoverySettings from "../../../utils/discoverySettings";
import { bindActionCreators, compose } from "redux";
import { updateDiscoverySettings } from "../../../store/actions/discoveries";
import { connect } from "react-redux";
import { useSetting } from "../../../components/SettingsProvider";

export const CostOfStatusQuoChartContext = createContext();

export const CostOfStatusQuoChartModes = {
  COST_OF_STATUS_QUO: "costOfStatusQuo",
  BENEFIT_SUMMARY: "benefitSummary"
};

const CostOfStatusQuoChartProvider = ({
  discoveryId,
  isAuthenticated,
  updateDiscoverySettings,
  chartModeForDiscovery,
  children
}) => {
  const chartModeDefault = useSetting(
    "discovery.valueHypothesis.costOfStatusQuoChart.defaultMode",
    CostOfStatusQuoChartModes.BENEFIT_SUMMARY
  );
  const [chartMode, setChartMode] = useState(
    chartModeForDiscovery !== undefined
      ? chartModeForDiscovery
      : chartModeDefault
  );

  const updateChartMode = (mode) => {
    setChartMode(mode);

    if (isAuthenticated) {
      const changes = {};
      changes[DiscoverySettings.COST_OF_STATUS_QUO_CHART_MODE] = mode;
      updateDiscoverySettings({ discoveryId, changes });
    }
  };

  return (
    <CostOfStatusQuoChartContext.Provider
      value={{
        chartMode,
        updateChartMode
      }}
    >
      {children}
    </CostOfStatusQuoChartContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  chartModeForDiscovery: selectDiscoverySetting(
    state,
    DiscoverySettings.COST_OF_STATUS_QUO_CHART_MODE
  ),
  discoveryId: selectDiscoveryId(state),
  isAuthenticated: isAuthenticated(state)
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDiscoverySettings
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  CostOfStatusQuoChartProvider
);
